import { render, staticRenderFns } from "./link-document-item-text.vue?vue&type=template&id=9d764348&"
import script from "./link-document-item-text.vue?vue&type=script&lang=js&"
export * from "./link-document-item-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports